export default __webpack_public_path__ + "static/media/down-arrow-icon.9fcd76b3.svg";